module.exports = __webpack_public_path__ + "static/media/soccerGraphic.66eeb354.png";